import Head from 'next/head';
import React from 'react';

export interface SEOProps {
  title: string;
  description: string;
  url: string;
  og?: { description: string; image: string; title: string; imageAlt: string };
}

export const SEO = ({ title, description, url, og }: SEOProps) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {og && (
        <>
          <meta property="og:type" content="website" />
          <meta property="og:title" content={og.title} />
          <meta property="og:description" content={og.description} />
          <meta property="og:image" content={og.image} />
          <meta property="og:image:alt" content={og.imageAlt} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:creator" content="@toggle_ai" />
          <meta name="twitter:description" content={og.description} />
          <meta name="twitter:domain" content="https://toggle.ai/" />
          <meta name="twitter:image:src" content={og.image} />
          <meta name="twitter:image:alt" content={og.imageAlt} />
          <meta name="twitter:site" content="@toggle_ai" />
          <meta name="twitter:title" content={og.title} />
        </>
      )}
    </Head>
  );
};
